export { default as recoveryseed } from './recovery_seed.svg';
export { default as instructions } from './instructions.svg';
export { default as treatment } from './treatment.svg';
export { default as download } from './download.svg';



// WEBPACK FOOTER //
// ./src/components/Skywallet/images/index.js